import flagEn from "../images/flag-en.svg";
import flagCs from "../images/flag-cs.svg";
import flagPl from "../images/flag-pl.svg";
import flagEs from "../images/flag-es.svg";

export const DEFAULT_LANG = "en";
export const LANGUAGES = ["en", "cs", "pl", "es"];
export const LANGUAGES_IMAGES = [flagEn, flagCs, flagPl, flagEs];